import { bootstrapApplication } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { passwordResetPathFromHash } from './app/core/auth/password-reset-link';

registerLocaleData(localeIt);

const passwordResetPath = passwordResetPathFromHash(window.location.hash);
if (passwordResetPath) {
  window.history.replaceState(null, '', passwordResetPath);
}

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
